// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"impressum_productcontent__rjLGE"};